const GROUP_FN_PRODUCEIT_PRODUCTION_MANAGER = 'GROUP_FN_PRODUCEIT_PRODUCTION_MANAGER';
const GROUP_FN_PRODUCEIT_POP_PRODUCTION_MANAGER = 'GROUP_FN_PRODUCEIT_POP_PRODUCTION_MANAGER';
const GROUP_FN_PRODUCEIT_FSR_PRODUCTION_MANAGER = 'GROUP_FN_PRODUCEIT_FSR_PRODUCTION_MANAGER';
const GROUP_FN_PRODUCEIT_BIF_PRODUCTION_MANAGER = 'GROUP_FN_PRODUCEIT_BIF_PRODUCTION_MANAGER';
const GROUP_FN_PRODUCEIT_IHA_PRODUCTION_MANAGER = 'GROUP_FN_PRODUCEIT_IHA_PRODUCTION_MANAGER';
const GROUP_FN_PRODUCEIT_3RD_PARTY_CARD_PRODUCTION_MANAGER = 'GROUP_FN_PRODUCEIT_3RD_PARTY_CARD_PRODUCTION_MANAGER';
const GROUP_FN_PRODUCEIT_FINANCE_APPROVER_PREPAID = 'GROUP_FN_PRODUCEIT_FINANCE_APPROVER_PREPAID';
const GROUP_FN_PRODUCEIT_FINANCE_APPROVER_REBILL = 'GROUP_FN_PRODUCEIT_FINANCE_APPROVER_REBILL';
const GROUP_FN_PRODUCEIT_FINANCE_APPROVER_INCOMM_PAYS = 'GROUP_FN_PRODUCEIT_FINANCE_APPROVER_INCOMM_PAYS';
const GROUP_FN_PRODUCEIT_POP_PRODUCTION_FINANCE_APPROVER = 'GROUP_FN_PRODUCEIT_POP_PRODUCTION_FINANCE_APPROVER';
const GROUP_FN_PRODUCEIT_TRAFFIC_MANAGER = 'GROUP_FN_PRODUCEIT_TRAFFIC_MANAGER';
const GROUP_FN_PRODUCEIT_PRODUCTION_TRAFFIC_MANAGER = 'GROUP_FN_PRODUCEIT_PRODUCTION_TRAFFIC_MANAGER';
const GROUP_FN_PRODUCEIT_CARD_DESIGN_TRAFFIC_MANAGER = 'GROUP_FN_PRODUCEIT_CARD_DESIGN_TRAFFIC_MANAGER';
const FN_PRODUCEIT_CARD_DESIGN_TRAFFIC_MANAGER = 'FN_PRODUCEIT_CARD_DESIGN_TRAFFIC_MANAGER';
const GROUP_FN_PRODUCEIT_POP_DESIGN_TRAFFIC_MANAGER = 'GROUP_FN_PRODUCEIT_POP_DESIGN_TRAFFIC_MANAGER';
const FN_PRODUCEIT_POP_DESIGN_TRAFFIC_MANAGER = 'FN_PRODUCEIT_POP_DESIGN_TRAFFIC_MANAGER';
const GROUP_FN_PRODUCEIT_IMAGE_TRAFFIC_MANAGER = 'GROUP_FN_PRODUCEIT_IMAGE_TRAFFIC_MANAGER';
const FN_PRODUCEIT_IMAGE_TRAFFIC_MANAGER = 'FN_PRODUCEIT_IMAGE_TRAFFIC_MANAGER';

const GROUP_FN_PRODUCEIT_POP_PRODUCTION_TRAFFIC_MANAGER = 'GROUP_FN_PRODUCEIT_POP_PRODUCTION_TRAFFIC_MANAGER';
const GROUP_FN_PRODUCEIT_3RD_PARTY_PRODUCTION_TRAFFIC_MANAGER = 'GROUP_FN_PRODUCEIT_3RD_PARTY_PRODUCTION_TRAFFIC_MANAGER';
const GROUP_FN_PRODUCEIT_DESIGNER = 'GROUP_FN_PRODUCEIT_DESIGNER';
const GROUP_FN_PRODUCEIT_CREATIVE_DIRECTOR = 'GROUP_FN_PRODUCEIT_CREATIVE_DIRECTOR';
const GROUP_FN_PRODUCEIT_FSM_AMERICAN_EXPRESS_GIFT = 'GROUP_FN_PRODUCEIT_FSM_AMERICAN_EXPRESS_GIFT';
const GROUP_FN_PRODUCEIT_FSM_BLUEBIRD = 'GROUP_FN_PRODUCEIT_FSM_BLUEBIRD';
const GROUP_FN_PRODUCEIT_FSM_CUENTAS = 'GROUP_FN_PRODUCEIT_FSM_CUENTAS';
const GROUP_FN_PRODUCEIT_FSM_FS_TAX = 'GROUP_FN_PRODUCEIT_FSM_FS_TAX';
const GROUP_FN_PRODUCEIT_FSM_MULTI_BRAND = 'GROUP_FN_PRODUCEIT_FSM_MULTI_BRAND';
const GROUP_FN_PRODUCEIT_FSM_SERVE = 'GROUP_FN_PRODUCEIT_FSM_SERVE';
const GROUP_FN_PRODUCEIT_FSM_OPEN_LOOP = 'GROUP_FN_PRODUCEIT_FSM_OPEN_LOOP';
const GROUP_FN_PRODUCEIT_FSM_MY_VANILLA = 'GROUP_FN_PRODUCEIT_FSM_MY_VANILLA';
const GROUP_FN_PRODUCEIT_FSM_SECURE_SPEND = 'GROUP_FN_PRODUCEIT_FSM_SECURE_SPEND';
const GROUP_FN_PRODUCEIT_FSM_VANILLA_DIRECT = 'GROUP_FN_PRODUCEIT_FSM_VANILLA_DIRECT';
const GROUP_FN_PRODUCEIT_FSM_VANILLA_GIFT = 'GROUP_FN_PRODUCEIT_FSM_VANILLA_GIFT';
const GROUP_FN_PRODUCEIT_FSM_VANILLA_GO = 'GROUP_FN_PRODUCEIT_FSM_VANILLA_GO';
const GROUP_FN_PRODUCEIT_POP_DESIGN_FINANCE_APPROVER = 'GROUP_FN_PRODUCEIT_POP_DESIGN_FINANCE_APPROVER';
const GROUP_FN_PRODUCEIT_ADMIN = 'GROUP_FN_PRODUCEIT_ADMIN';
const GROUP_FN_PRODUCEIT_USER = 'GROUP_FN_PRODUCEIT_USER';
const GROUP_FN_PRODUCEIT_SUPER_USER = 'GROUP_FN_PRODUCEIT_SUPER_USER';
const GROUP_FN_PRODUCEIT_SUBSTITUTION_ADMIN = 'GROUP_FN_PRODUCEIT_SUBSTITUTION_ADMIN';
const GROUP_FN_PRODUCEIT_PO_REPORT_USER = 'GROUP_FN_PRODUCEIT_PO_REPORT_USER';
const GROUP_FN_PRODUCEIT_CARD_DESIGN_FS_DNBC_APPROVER = 'GROUP_FN_PRODUCEIT_CARD_DESIGN_FS_DNBC_APPROVER';

export class PermissionGroups {
  static readonly PRODUCTION_MANAGER = GROUP_FN_PRODUCEIT_PRODUCTION_MANAGER;
  static readonly POP_PRODUCTION_MANAGER = GROUP_FN_PRODUCEIT_POP_PRODUCTION_MANAGER;
  static readonly FSR_PRODUCTION_MANAGER = GROUP_FN_PRODUCEIT_FSR_PRODUCTION_MANAGER;
  static readonly BIF_PRODUCTION_MANAGER = GROUP_FN_PRODUCEIT_BIF_PRODUCTION_MANAGER;
  static readonly IHA_PRODUCTION_MANAGER = GROUP_FN_PRODUCEIT_IHA_PRODUCTION_MANAGER;
  static readonly ['3RD_PARTY_CARD_PRODUCTION_MANAGER'] = GROUP_FN_PRODUCEIT_3RD_PARTY_CARD_PRODUCTION_MANAGER;
  static readonly FINANCE_APPROVER_PREPAID = GROUP_FN_PRODUCEIT_FINANCE_APPROVER_PREPAID;
  static readonly FINANCE_APPROVER_REBILL = GROUP_FN_PRODUCEIT_FINANCE_APPROVER_REBILL;
  static readonly FINANCE_APPROVER_INCOMM_PAYS = GROUP_FN_PRODUCEIT_FINANCE_APPROVER_INCOMM_PAYS;
  static readonly POP_PRODUCTION_FINANCE_APPROVER = GROUP_FN_PRODUCEIT_POP_PRODUCTION_FINANCE_APPROVER;
  static readonly TRAFFIC_MANAGER = GROUP_FN_PRODUCEIT_TRAFFIC_MANAGER;
  static readonly PRODUCTION_TRAFFIC_MANAGER = GROUP_FN_PRODUCEIT_PRODUCTION_TRAFFIC_MANAGER;
  static readonly CARD_DESIGN_TRAFFIC_MANAGER = GROUP_FN_PRODUCEIT_CARD_DESIGN_TRAFFIC_MANAGER;
  static readonly POP_DESIGN_TRAFFIC_MANAGER = GROUP_FN_PRODUCEIT_POP_DESIGN_TRAFFIC_MANAGER;
  static readonly IMAGE_TRAFFIC_MANAGER = GROUP_FN_PRODUCEIT_IMAGE_TRAFFIC_MANAGER;
  static readonly POP_PRODUCTION_TRAFFIC_MANAGER = GROUP_FN_PRODUCEIT_POP_PRODUCTION_TRAFFIC_MANAGER;
  static readonly ['3RD_PARTY_PRODUCTION_TRAFFIC_MANAGER'] = GROUP_FN_PRODUCEIT_3RD_PARTY_PRODUCTION_TRAFFIC_MANAGER;
  static readonly DESIGNER = GROUP_FN_PRODUCEIT_DESIGNER;
  static readonly CREATIVE_DIRECTOR = GROUP_FN_PRODUCEIT_CREATIVE_DIRECTOR;
  static readonly FSM_AMERICAN_EXPRESS_GIFT = GROUP_FN_PRODUCEIT_FSM_AMERICAN_EXPRESS_GIFT;
  static readonly FSM_BLUEBIRD = GROUP_FN_PRODUCEIT_FSM_BLUEBIRD;
  static readonly FSM_CUENTAS = GROUP_FN_PRODUCEIT_FSM_CUENTAS;
  static readonly FSM_FS_TAX = GROUP_FN_PRODUCEIT_FSM_FS_TAX;
  static readonly FSM_MULTI_BRAND = GROUP_FN_PRODUCEIT_FSM_MULTI_BRAND;
  static readonly FSM_OPEN_LOOP = GROUP_FN_PRODUCEIT_FSM_OPEN_LOOP;
  static readonly FSM_MY_VANILLA = GROUP_FN_PRODUCEIT_FSM_MY_VANILLA;
  static readonly FSM_SECURE_SPEND = GROUP_FN_PRODUCEIT_FSM_SECURE_SPEND;
  static readonly FSM_SERVE = GROUP_FN_PRODUCEIT_FSM_SERVE;
  static readonly FSM_VANILLA_DIRECT = GROUP_FN_PRODUCEIT_FSM_VANILLA_DIRECT;
  static readonly FSM_VANILLA_GIFT = GROUP_FN_PRODUCEIT_FSM_VANILLA_GIFT;
  static readonly FSM_VANILLA_GO = GROUP_FN_PRODUCEIT_FSM_VANILLA_GO;
  static readonly POP_DESIGN_FINANCE_APPROVER = GROUP_FN_PRODUCEIT_POP_DESIGN_FINANCE_APPROVER;
  static readonly ADMIN = GROUP_FN_PRODUCEIT_ADMIN;
  static readonly USER = GROUP_FN_PRODUCEIT_USER;
  static readonly SUPER_USER = GROUP_FN_PRODUCEIT_SUPER_USER;
  static readonly SUBSTITUTION_ADMIN = GROUP_FN_PRODUCEIT_SUBSTITUTION_ADMIN;
  static readonly PO_REPORT_USER = GROUP_FN_PRODUCEIT_PO_REPORT_USER;
  static readonly CARD_DESIGN_FS_DNBC_APPROVER = GROUP_FN_PRODUCEIT_CARD_DESIGN_FS_DNBC_APPROVER;
}

const ROLE_FN_PRODUCEIT_CARD_PROD_UPLD_ART_SUBMIT = 'FN_PRODUCEIT_CARD_PROD_UPLD_ART_SUBMIT';
const ROLE_FN_PRODUCEIT_CARD_PROD_UPLD_ART_ROUTE_BACK = 'FN_PRODUCEIT_CARD_PROD_UPLD_ART_ROUTE_BACK';
const ROLE_FN_PRODUCEIT_CARD_PROD_UPLD_ART_CANCEL = 'FN_PRODUCEIT_CARD_PROD_UPLD_ART_CANCEL';
const ROLE_FN_PRODUCEIT_CARD_DESIGN_DESIGNER_NAME_VIEW = 'FN_PRODUCEIT_CARD_DESIGN_DESIGNER_NAME_VIEW';
const ROLE_FN_PRODUCEIT_CARD_DESIGN_TM_EDIT = 'FN_PRODUCEIT_CARD_DESIGN_TM_EDIT';
const ROLE_FN_PRODUCEIT_CARD_DESIGN_CD_REVIEW_APPROVE = 'FN_PRODUCEIT_CARD_DESIGN_CD_REVIEW_APPROVE';
const ROLE_FN_PRODUCEIT_CARD_DESIGN_DSGN_PRCS_ROUTE_BACK = 'FN_PRODUCEIT_CARD_DESIGN_DSGN_PRCS_ROUTE_BACK';
const ROLE_FN_PRODUCEIT_CARD_DESIGN_CD_REVIEW_ROUT_BACK = 'FN_PRODUCEIT_CARD_DESIGN_CD_REVIEW_ROUT_BACK';
const ROLE_FN_PRODUCEIT_CARD_DESIGN_CD_REVIEW_CANCEL = 'FN_PRODUCEIT_CARD_DESIGN_CD_REVIEW_CANCEL';
const ROLE_FN_PRODUCEIT_CARD_DESIGN_IEC_PROOF_ROUTE_BACK = 'FN_PRODUCEIT_CARD_DESIGN_IEC_PROOF_ROUTE_BACK';
const ROLE_FN_PRODUCEIT_CARD_DESIGN_NOTATE_VERSION = 'FN_PRODUCEIT_CARD_DESIGN_NOTATE_VERSION';
const ROLE_FN_PRODUCEIT_POP_DESIGN_FS_REVIEW_1_EDIT = 'FN_PRODUCEIT_POP_DESIGN_FS_REVIEW_1_EDIT';
const ROLE_FN_PRODUCEIT_POP_DESIGN_FS_REVIEW_2_EDIT = 'FN_PRODUCEIT_POP_DESIGN_FS_REVIEW_2_EDIT';
const ROLE_FN_PRODUCEIT_POP_DESIGN_TM_EDIT = 'FN_PRODUCEIT_POP_DESIGN_TM_EDIT';
const ROLE_FN_PRODUCEIT_POP_DESIGN_CD_REVIEW_EDIT = 'FN_PRODUCEIT_POP_DESIGN_CD_REVIEW_EDIT';
const ROLE_FN_PRODUCEIT_POP_DESIGN_DESIGNER_NAME_VIEW = 'FN_PRODUCEIT_POP_DESIGN_DESIGNER_NAME_VIEW';
const ROLE_FN_PRODUCEIT_POP_DESIGN_NOTATE_VERSION = 'FN_PRODUCEIT_POP_DESIGN_NOTATE_VERSION';
const ROLE_FN_PRODUCEIT_POP_PROD_FIN_APPR_EDIT = 'FN_PRODUCEIT_POP_PROD_FIN_APPR_EDIT';
const ROLE_FN_PRODUCEIT_POP_PROD_UPLD_ART_EDIT = 'FN_PRODUCEIT_POP_PROD_UPLD_ART_EDIT';
const ROLE_FN_PRODUCEIT_IMAGE_DESIGNER_NAME_VIEW = 'FN_PRODUCEIT_IMAGE_DESIGNER_NAME_VIEW';
const ROLE_FN_PRODUCEIT_IMAGE_TM_EDIT = 'FN_PRODUCEIT_IMAGE_TM_EDIT';
const ROLE_FN_PRODUCEIT_IMAGE_NOTATE_VERSION = 'FN_PRODUCEIT_IMAGE_NOTATE_VERSION';
const ROLE_FN_PRODUCEIT_PO_REPORT = 'FN_PRODUCEIT_PO_REPORT';
const ROLE_FN_PRODUCEIT_MIMIC_USER = 'FN_PRODUCEIT_MIMIC_USER';
const ROLE_FN_PRODUCEIT_ADMIN_USER = 'FN_PRODUCEIT_ADMIN_USER';

export class PermissionRoles {
  static readonly CARD_PROD_UPLD_ART_SUBMIT = ROLE_FN_PRODUCEIT_CARD_PROD_UPLD_ART_SUBMIT;
  static readonly CARD_PROD_UPLD_ART_ROUTE_BACK = ROLE_FN_PRODUCEIT_CARD_PROD_UPLD_ART_ROUTE_BACK;
  static readonly CARD_PROD_UPLD_ART_CANCEL = ROLE_FN_PRODUCEIT_CARD_PROD_UPLD_ART_CANCEL;
  static readonly CARD_DESIGN_DESIGNER_NAME_VIEW = ROLE_FN_PRODUCEIT_CARD_DESIGN_DESIGNER_NAME_VIEW;
  static readonly CARD_DESIGN_TM_EDIT = ROLE_FN_PRODUCEIT_CARD_DESIGN_TM_EDIT;
  static readonly CARD_DESIGN_CD_REVIEW_APPROVE = ROLE_FN_PRODUCEIT_CARD_DESIGN_CD_REVIEW_APPROVE;
  static readonly CARD_DESIGN_DSGN_PRCS_ROUTE_BACK = ROLE_FN_PRODUCEIT_CARD_DESIGN_DSGN_PRCS_ROUTE_BACK;
  static readonly CARD_DESIGN_CD_REVIEW_ROUT_BACK = ROLE_FN_PRODUCEIT_CARD_DESIGN_CD_REVIEW_ROUT_BACK;
  static readonly CARD_DESIGN_CD_REVIEW_CANCEL = ROLE_FN_PRODUCEIT_CARD_DESIGN_CD_REVIEW_CANCEL;
  static readonly CARD_DESIGN_IEC_PROOF_ROUTE_BACK = ROLE_FN_PRODUCEIT_CARD_DESIGN_IEC_PROOF_ROUTE_BACK;
  static readonly CARD_DESIGN_NOTATE_VERSION = ROLE_FN_PRODUCEIT_CARD_DESIGN_NOTATE_VERSION;
  static readonly POP_DESIGN_FS_REVIEW_1_EDIT = ROLE_FN_PRODUCEIT_POP_DESIGN_FS_REVIEW_1_EDIT;
  static readonly POP_DESIGN_FS_REVIEW_2_EDIT = ROLE_FN_PRODUCEIT_POP_DESIGN_FS_REVIEW_2_EDIT;
  static readonly POP_DESIGN_TM_EDIT = ROLE_FN_PRODUCEIT_POP_DESIGN_TM_EDIT;
  static readonly POP_DESIGN_CD_REVIEW_EDIT = ROLE_FN_PRODUCEIT_POP_DESIGN_CD_REVIEW_EDIT;
  static readonly POP_DESIGN_DESIGNER_NAME_VIEW = ROLE_FN_PRODUCEIT_POP_DESIGN_DESIGNER_NAME_VIEW;
  static readonly POP_DESIGN_NOTATE_VERSION = ROLE_FN_PRODUCEIT_POP_DESIGN_NOTATE_VERSION;
  static readonly POP_PROD_FIN_APPR_EDIT = ROLE_FN_PRODUCEIT_POP_PROD_FIN_APPR_EDIT;
  static readonly POP_PROD_UPLD_ART_EDIT = ROLE_FN_PRODUCEIT_POP_PROD_UPLD_ART_EDIT;
  static readonly IMAGE_DESIGNER_NAME_VIEW = ROLE_FN_PRODUCEIT_IMAGE_DESIGNER_NAME_VIEW;
  static readonly IMAGE_TM_EDIT = ROLE_FN_PRODUCEIT_IMAGE_TM_EDIT;
  static readonly IMAGE_NOTATE_VERSION = ROLE_FN_PRODUCEIT_IMAGE_NOTATE_VERSION;
  static readonly PO_REPORT = ROLE_FN_PRODUCEIT_PO_REPORT;
  static readonly MIMIC_USER = ROLE_FN_PRODUCEIT_MIMIC_USER;
  static readonly ADMIN_USER = ROLE_FN_PRODUCEIT_ADMIN_USER;
}

const REQUEST_DETAILS_REQUESTER = 'REQUESTER';
// Can assign designer
const CARD_DESIGN_REQUEST_ASSIGNED_PREP_ARTIFACT_DESIGNER = 'ASSIGNED_PREP_ARTIFACT_DESIGNER';
const POP_DESIGN_REQUEST_ASSIGNED_PREP_ARTIFACT_DESIGNER = 'ASSIGNED_PREP_ARTIFACT_DESIGNER';
const REQUEST_STAGE_ASSIGNEE_STEP_INCLUDED = 'ASSIGNEE_STEP_INCLUDED';
const ASSIGNED_TM = 'ASSIGNED_TM';
const ASSIGNED_DESIGNER = 'ASSIGNED_DESIGNER';
const ASSIGNED_CREATIVE_DIRECTOR = 'ASSIGNED_CREATIVE_DIRECTOR';
const PPM = 'PPM';

export class SpecificRoles {
  static readonly REQUEST_DETAILS_REQUESTER = REQUEST_DETAILS_REQUESTER;
  static readonly CARD_DESIGN_REQUEST_ASSIGNED_PREP_ARTIFACT_DESIGNER = CARD_DESIGN_REQUEST_ASSIGNED_PREP_ARTIFACT_DESIGNER;
  static readonly POP_DESIGN_REQUEST_ASSIGNED_PREP_ARTIFACT_DESIGNER = POP_DESIGN_REQUEST_ASSIGNED_PREP_ARTIFACT_DESIGNER;
  static readonly REQUEST_STAGE_ASSIGNEE_STEP_INCLUDED = REQUEST_STAGE_ASSIGNEE_STEP_INCLUDED;
  static readonly ASSIGNED_TM = ASSIGNED_TM;
  static readonly ASSIGNED_DESIGNER = ASSIGNED_DESIGNER;
  static readonly ASSIGNED_CREATIVE_DIRECTOR = ASSIGNED_CREATIVE_DIRECTOR;
  static readonly PPM = PPM;
}

export class TrafficManagers {
  static readonly CDR = FN_PRODUCEIT_CARD_DESIGN_TRAFFIC_MANAGER;
  static readonly PDR = FN_PRODUCEIT_POP_DESIGN_TRAFFIC_MANAGER;
  static readonly IR = FN_PRODUCEIT_IMAGE_TRAFFIC_MANAGER;
}

export const POP_DESIGN_REQUEST_STAGE_REQUEST_DETAILS = 'REQUEST_DETAILS';
export const POP_DESIGN_REQUEST_STAGE_FINANCIAL_SERVICES_REVIEW = 'FINANCIAL_SERVICES_REVIEW';
export const POP_DESIGN_REQUEST_STAGE_TM_REVIEW = 'TM_REVIEW';
export const POP_DESIGN_REQUEST_STAGE_DESIGN_PROCESS = 'DESIGN_PROCESS';
export const POP_DESIGN_REQUEST_STAGE_TM_REVIEW_2 = 'TM_REVIEW_2';
export const POP_DESIGN_REQUEST_STAGE_CREATIVE_DIRECTOR_REVIEW = 'CREATIVE_DIRECTOR_REVIEW';
export const POP_DESIGN_REQUEST_STAGE_FINANCIAL_SERVICES_REVIEW_2 = 'FINANCIAL_SERVICES_REVIEW_2';
export const POP_DESIGN_REQUEST_STAGE_BANK_APPROVAL = 'BANK_APPROVAL';
export const POP_DESIGN_REQUEST_STAGE_INT_EXT_CLIENT_PROOF = 'INT_EXT_CLIENT_PROOF';
export const POP_DESIGN_REQUEST_STAGE_PREP_POST_ARTIFACTS = 'PREP_POST_ARTIFACTS';
export const POP_DESIGN_REQUEST_STAGE_TM_REVIEW_3 = 'TM_REVIEW_3';
export const POP_DESIGN_REQUEST_STAGE_PREP_ARTIFACTS = 'PREP_ARTIFACTS';
export const POP_DESIGN_REQUEST_STAGE_POST_ARTIFACTS = 'POST_ARTIFACTS';

export const CARD_DESIGN_REQUEST_STAGE_REQUEST_DETAILS = 'REQUEST_DETAILS';
export const CARD_DESIGN_REQUEST_STAGE_TM_REVIEW = 'TM_REVIEW';
export const CARD_DESIGN_REQUEST_STAGE_DESIGN_PROCESS = 'DESIGN_PROCESS';
export const CARD_DESIGN_REQUEST_STAGE_TM_REVIEW_2 = 'TM_REVIEW_2';
export const CARD_DESIGN_REQUEST_STAGE_TM_REVIEW_3 = 'TM_REVIEW_3';
export const CARD_DESIGN_REQUEST_STAGE_PREP_ARTIFACTS = 'PREP_ARTIFACTS';
export const CARD_DESIGN_REQUEST_STAGE_POST_ARTIFACTS = 'POST_ARTIFACTS';

export const CARD_DESIGN_REQUEST_STAGE_CREATIVE_DIRECTOR_REVIEW = 'CREATIVE_DIRECTOR_REVIEW';
export const CARD_DESIGN_REQUEST_STAGE_INT_EXT_CLIENT_PROOF = 'INT_EXT_CLIENT_PROOF';
export const CARD_DESIGN_REQUEST_STAGE_FINANCIAL_SERVICES_APPROVAL_BANK_REVIEW = 'FINANCIAL_SERVICES_APPROVAL_BANK_REVIEW';
export const CARD_DESIGN_REQUEST_STAGE_PREP_POST_ARTIFACTS = 'PREP_POST_ARTIFACTS';

export const UserRoles = {
  PRODUCTION_REQUEST: {
    CREATE_REQUEST: 'ROLE_FN_PRODUCEIT_CARD_PROD_REQUEST_CREATE',
    REQUEST_DETAILS: {
      'step-delete': REQUEST_DETAILS_REQUESTER,
      'step-save': REQUEST_DETAILS_REQUESTER,
      'step-submit': REQUEST_DETAILS_REQUESTER
    },
    REQUEST_REVIEW: {
      'step-back': ['PRINT_PRODUCTION_MANAGER', 'ASSIGNEE_STEP_INCLUDED'],
      'step-submit': ['PRINT_PRODUCTION_MANAGER', 'ASSIGNEE_STEP_INCLUDED']
    },
    FINANCE_APPROVAL: {
      'step-approve': ['PRINT_PRODUCTION_MANAGER', 'ASSIGNEE_STEP_INCLUDED'],
      'step-back': ['PRINT_PRODUCTION_MANAGER', 'ASSIGNEE_STEP_INCLUDED']
    },
    UPLOAD_ARTWORK: {
      'step-submit': ['ROLE_FN_PRODUCEIT_CARD_PROD_UPLD_ART_SUBMIT', 'PRINT_PRODUCTION_MANAGER'],
      'step-back': ['ROLE_FN_PRODUCEIT_CARD_PROD_UPLD_ART_ROUTE_BACK', 'PRINT_PRODUCTION_MANAGER'],
      'step-cancel': ['ROLE_FN_PRODUCEIT_CARD_PROD_UPLD_ART_CANCEL', 'PRINT_PRODUCTION_MANAGER']
    },
    ART_APPROVAL: {
      'step-approve': ['PRINT_PRODUCTION_MANAGER', 'PRODUCT_OWNER'],
      'step-back': ['PRINT_PRODUCTION_MANAGER', 'PRODUCT_OWNER'],
      'step-cancel': ['PRINT_PRODUCTION_MANAGER', 'PRODUCT_OWNER']
    },
    PO_SOW: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-cancel': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    COMMITTEE_APPROVAL: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-cancel': 'PRINT_PRODUCTION_MANAGER',
      'step-approve': 'PRINT_PRODUCTION_MANAGER'
    },
    PO_APPROVAL: {
      ENABLED: [SpecificRoles.PPM, 'GROUP_FN_PRODUCEIT_PO_APPROVER_1', 'GROUP_FN_PRODUCEIT_PO_APPROVER_2'],
    },
    PRINT: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-close': 'PRINT_PRODUCTION_MANAGER'
    },
    PRODUCTION_MANAGER: 'GROUP_FN_PRODUCEIT_PRODUCTION_MANAGER',
    TRAFFIC_MANAGER: PermissionGroups.PRODUCTION_TRAFFIC_MANAGER
  },
  CARD_DESIGN_REQUEST: {
    CREATE_REQUEST: 'ROLE_FN_PRODUCEIT_CARD_DESIGN_REQUEST_CREATE',
    [CARD_DESIGN_REQUEST_STAGE_REQUEST_DETAILS]: {
      'step-delete': REQUEST_DETAILS_REQUESTER,
      'step-save': REQUEST_DETAILS_REQUESTER,
      'step-submit': REQUEST_DETAILS_REQUESTER
    },
    [CARD_DESIGN_REQUEST_STAGE_TM_REVIEW]: {
      'step-submit': [ASSIGNED_TM],
      'step-back': [ASSIGNED_TM],
      'step-save': [ASSIGNED_TM],
      'view-designer-name': 'ANY'
    },
    [CARD_DESIGN_REQUEST_STAGE_DESIGN_PROCESS]: {
      'step-submit': [ASSIGNED_DESIGNER],
      'step-back': [ASSIGNED_DESIGNER],
      'step-save': [ASSIGNED_DESIGNER]
    },
    [CARD_DESIGN_REQUEST_STAGE_TM_REVIEW_2]: {
      'step-submit': [ASSIGNED_TM],
      'step-back': [ASSIGNED_TM],
      'view-creative-director-name': 'ANY'
    },
    [CARD_DESIGN_REQUEST_STAGE_CREATIVE_DIRECTOR_REVIEW]: {
      'step-submit': [ASSIGNED_CREATIVE_DIRECTOR],
      'step-back': [ASSIGNED_CREATIVE_DIRECTOR],
      'step-cancel': [ASSIGNED_CREATIVE_DIRECTOR]
    },
    [CARD_DESIGN_REQUEST_STAGE_INT_EXT_CLIENT_PROOF]: {
      'step-back': [REQUEST_DETAILS_REQUESTER, 'ROLE_FN_PRODUCEIT_CARD_DESIGN_IEC_PROOF_ROUTE_BACK'],
      'step-submit': REQUEST_DETAILS_REQUESTER,
      VIEW: 'ROLE_FN_PRODUCEIT_CARD_DESIGN_IEC_PROOF_VIEW'
    },
    [CARD_DESIGN_REQUEST_STAGE_FINANCIAL_SERVICES_APPROVAL_BANK_REVIEW]: {
      'step-submit': 'ROLE_FN_PRODUCEIT_CARD_DESIGN_FS_DNBC_APPROVER',
      'step-back': 'ROLE_FN_PRODUCEIT_CARD_DESIGN_FS_DNBC_ROUTE_BACK',
    },
    [CARD_DESIGN_REQUEST_STAGE_TM_REVIEW_3]: {
      'step-submit': [ASSIGNED_TM],
      'step-back': [ASSIGNED_TM]
    },
    [CARD_DESIGN_REQUEST_STAGE_PREP_ARTIFACTS]: {
      'step-submit': [CARD_DESIGN_REQUEST_ASSIGNED_PREP_ARTIFACT_DESIGNER],
      'step-save': [CARD_DESIGN_REQUEST_ASSIGNED_PREP_ARTIFACT_DESIGNER],
      'step-back': [CARD_DESIGN_REQUEST_ASSIGNED_PREP_ARTIFACT_DESIGNER],
      'auto-assign': GROUP_FN_PRODUCEIT_DESIGNER,
      'can-assign-designer': [
        GROUP_FN_PRODUCEIT_CARD_DESIGN_TRAFFIC_MANAGER,
        GROUP_FN_PRODUCEIT_DESIGNER,
        ROLE_FN_PRODUCEIT_CARD_DESIGN_CD_REVIEW_APPROVE,
        GROUP_FN_PRODUCEIT_CREATIVE_DIRECTOR
      ]
    },
    [CARD_DESIGN_REQUEST_STAGE_POST_ARTIFACTS]: {
      'step-close': 'ROLE_FN_PRODUCEIT_CARD_DESIGN_TM_EDIT',
      'step-back': 'ROLE_FN_PRODUCEIT_CARD_DESIGN_TM_EDIT'
    },
    DESIGNER: 'DESIGNER',
    DESIGNER_GROUP: 'GROUP_FN_PRODUCEIT_DESIGNER',
    TRAFFIC_MANAGERS: 'GROUP_FN_PRODUCEIT_CARD_DESIGN_TRAFFIC_MANAGER',
    TRAFFIC_MANAGER: SpecificRoles.ASSIGNED_TM,
    CREATIVE_DIRECTOR: 'CREATIVE_DIRECTOR',
    CREATIVE_DIRECTOR_GROUP: 'GROUP_FN_PRODUCEIT_CREATIVE_DIRECTOR',
    APPROVAL_MANAGER_ANNOTATE: 'ROLE_FN_PRODUCEIT_CARD_DESIGN_NOTATE_VERSION',
    CAN_ASSIGN_TM: 'ROLE_FN_PRODUCEIT_CARD_DESIGN_TM_EDIT',
    TM_AUTO_ASSIGN: 'ROLE_FN_PRODUCEIT_CARD_DESIGN_TM_EDIT',
    CAN_ASSIGN_DESIGNER: ['GROUP_FN_PRODUCEIT_DESIGNER', GROUP_FN_PRODUCEIT_CARD_DESIGN_TRAFFIC_MANAGER],
    DESIGNER_AUTO_ASSIGN: 'GROUP_FN_PRODUCEIT_DESIGNER',
    FS_DNBC_APPROVER: 'GROUP_FN_PRODUCEIT_CARD_DESIGN_FS_DNBC_APPROVER',
    CAN_ASSIGN_CREATIVE_DIRECTOR: ['GROUP_FN_PRODUCEIT_CREATIVE_DIRECTOR', GROUP_FN_PRODUCEIT_POP_DESIGN_TRAFFIC_MANAGER],
    CREATIVE_DIRECTOR_AUTO_ASSIGN: 'GROUP_FN_PRODUCEIT_DESIGNER'
  },
  POP_DESIGN_REQUEST: {
    [POP_DESIGN_REQUEST_STAGE_REQUEST_DETAILS]: {
      'step-delete': REQUEST_DETAILS_REQUESTER,
      'step-save': REQUEST_DETAILS_REQUESTER,
      'step-submit': REQUEST_DETAILS_REQUESTER
    },
    [POP_DESIGN_REQUEST_STAGE_FINANCIAL_SERVICES_REVIEW]: {
      'step-back': ['ASSIGNEE_STEP_INCLUDED'],
      'step-submit': ['ASSIGNEE_STEP_INCLUDED'],
      'upload-art-files': 'ROLE_FN_PRODUCEIT_POP_DESIGN_FS_REVIEW_1_EDIT'
    },
    [POP_DESIGN_REQUEST_STAGE_TM_REVIEW]: {
      'step-back': [ASSIGNED_TM],
      'step-submit': [ASSIGNED_TM],
      'step-save': [ASSIGNED_TM],
      'view-designer-name': 'ANY'
    },
    [POP_DESIGN_REQUEST_STAGE_DESIGN_PROCESS]: {
      'step-submit': [ASSIGNED_DESIGNER],
      'step-back': [ASSIGNED_DESIGNER],
      'step-save': [ASSIGNED_DESIGNER]
    },
    [POP_DESIGN_REQUEST_STAGE_TM_REVIEW_2]: {
      'step-back': [ASSIGNED_TM],
      'step-submit': [ASSIGNED_TM],
      'view-creative-director-name': 'ANY'
    },
    [POP_DESIGN_REQUEST_STAGE_CREATIVE_DIRECTOR_REVIEW]: {
      'step-back': [ASSIGNED_CREATIVE_DIRECTOR],
      'step-cancel': [ASSIGNED_CREATIVE_DIRECTOR],
      'step-submit': [ASSIGNED_CREATIVE_DIRECTOR]
    },
    [POP_DESIGN_REQUEST_STAGE_FINANCIAL_SERVICES_REVIEW_2]: {
      'step-back': 'ROLE_FN_PRODUCEIT_POP_DESIGN_FS_REVIEW_2_EDIT',
      'step-submit': 'ROLE_FN_PRODUCEIT_POP_DESIGN_FS_REVIEW_2_EDIT',
      'upload-art-files': 'ROLE_FN_PRODUCEIT_POP_DESIGN_FS_REVIEW_2_EDIT'
    },
    [POP_DESIGN_REQUEST_STAGE_BANK_APPROVAL]: {
      'step-back': 'ROLE_FN_PRODUCEIT_POP_DESIGN_BANK_APPROVAL_ROUTE_BACK',
      'step-approve': 'ROLE_FN_PRODUCEIT_POP_DESIGN_BANK_APPROVAL_APPROVER',
      'step-submit': 'ROLE_FN_PRODUCEIT_POP_DESIGN_BANK_APPROVAL_APPROVER'
    },
    [POP_DESIGN_REQUEST_STAGE_INT_EXT_CLIENT_PROOF]: {
      'step-back': REQUEST_DETAILS_REQUESTER,
      'step-submit': REQUEST_DETAILS_REQUESTER
    },
    [POP_DESIGN_REQUEST_STAGE_TM_REVIEW_3]: {
      'step-submit': [ASSIGNED_TM],
      'step-back': [ASSIGNED_TM]
    },
    [POP_DESIGN_REQUEST_STAGE_PREP_ARTIFACTS]: {
      'step-submit': [POP_DESIGN_REQUEST_ASSIGNED_PREP_ARTIFACT_DESIGNER],
      'step-save': [POP_DESIGN_REQUEST_ASSIGNED_PREP_ARTIFACT_DESIGNER],
      'step-back': [POP_DESIGN_REQUEST_ASSIGNED_PREP_ARTIFACT_DESIGNER],
      'auto-assign': GROUP_FN_PRODUCEIT_DESIGNER,
      'can-assign-designer': [
        GROUP_FN_PRODUCEIT_POP_DESIGN_TRAFFIC_MANAGER,
        GROUP_FN_PRODUCEIT_DESIGNER,
        ROLE_FN_PRODUCEIT_POP_DESIGN_CD_REVIEW_EDIT,
        GROUP_FN_PRODUCEIT_CREATIVE_DIRECTOR
      ]
    },
    [POP_DESIGN_REQUEST_STAGE_POST_ARTIFACTS]: {
      'step-close': 'ROLE_FN_PRODUCEIT_POP_DESIGN_TM_EDIT',
      'step-back': 'ROLE_FN_PRODUCEIT_POP_DESIGN_TM_EDIT'
    },
    DESIGNER: 'DESIGNER',
    DESIGNER_GROUP: 'GROUP_FN_PRODUCEIT_DESIGNER',
    TRAFFIC_MANAGERS: 'GROUP_FN_PRODUCEIT_POP_DESIGN_TRAFFIC_MANAGER',
    TRAFFIC_MANAGER: SpecificRoles.ASSIGNED_TM,
    CREATIVE_DIRECTOR: 'CREATIVE_DIRECTOR',
    CREATIVE_DIRECTOR_GROUP: 'GROUP_FN_PRODUCEIT_CREATIVE_DIRECTOR',
    FINANCE_APPROVER: 'GROUP_FN_PRODUCEIT_POP_DESIGN_FINANCE_APPROVER',
    APPROVAL_MANAGER_ANNOTATE: 'ROLE_FN_PRODUCEIT_POP_DESIGN_NOTATE_VERSION',
    CAN_ASSIGN_TM: 'ROLE_FN_PRODUCEIT_POP_DESIGN_TM_EDIT',
    TM_AUTO_ASSIGN: 'ROLE_FN_PRODUCEIT_POP_DESIGN_TM_EDIT',
    CAN_ASSIGN_DESIGNER: ['GROUP_FN_PRODUCEIT_DESIGNER', GROUP_FN_PRODUCEIT_POP_DESIGN_TRAFFIC_MANAGER],
    DESIGNER_AUTO_ASSIGN: 'GROUP_FN_PRODUCEIT_DESIGNER',
    CAN_ASSIGN_CREATIVE_DIRECTOR: ['GROUP_FN_PRODUCEIT_CREATIVE_DIRECTOR', GROUP_FN_PRODUCEIT_POP_DESIGN_TRAFFIC_MANAGER],
    CREATIVE_DIRECTOR_AUTO_ASSIGN: 'GROUP_FN_PRODUCEIT_DESIGNER'
  },
  POP_PRODUCTION_REQUEST: {
    REQUEST_DETAILS: {
      'step-delete': REQUEST_DETAILS_REQUESTER,
      'step-save': REQUEST_DETAILS_REQUESTER,
      'step-submit': REQUEST_DETAILS_REQUESTER
    },
    PRODUCTION_REVIEW: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-cancel': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    PRINTER_QUOTE_REQUEST: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    INTERNAL_REQUESTOR_REVIEW: {
      'step-back': REQUEST_DETAILS_REQUESTER,
      'step-submit': REQUEST_DETAILS_REQUESTER
    },
    FINANCE_APPROVAL: {
      'step-back': 'ROLE_FN_PRODUCEIT_POP_PROD_FIN_APPR_EDIT',
      'step-approve': 'ROLE_FN_PRODUCEIT_POP_PROD_FIN_APPR_EDIT'
    },
    UPLOAD_ARTWORK: {
      'step-back': 'ROLE_FN_PRODUCEIT_POP_PROD_UPLD_ART_EDIT',
      'step-submit': 'ROLE_FN_PRODUCEIT_POP_PROD_UPLD_ART_EDIT'
    },
    PO_SOW: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    PRINTER_PROOF_REQUEST: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-cancel': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    INTERNAL_PRINTER_PROOF_REVIEW: {
      'step-back': REQUEST_DETAILS_REQUESTER,
      'step-approve': REQUEST_DETAILS_REQUESTER
    },
    PO_APPROVAL: {
      ENABLED: [SpecificRoles.PPM, 'GROUP_FN_PRODUCEIT_PO_APPROVER_1', 'GROUP_FN_PRODUCEIT_PO_APPROVER_2'],
    },
    PRINT: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-close': 'PRINT_PRODUCTION_MANAGER'
    },
    PRODUCTION_MANAGER: 'GROUP_FN_PRODUCEIT_POP_PRODUCTION_MANAGER',
    TRAFFIC_MANAGER: PermissionGroups.POP_PRODUCTION_TRAFFIC_MANAGER
  },
  FINANCIAL_SERVICES_REQUEST: {
    REQUEST_DETAILS: {
      'step-delete': REQUEST_DETAILS_REQUESTER,
      'step-save': REQUEST_DETAILS_REQUESTER,
      'step-submit': REQUEST_DETAILS_REQUESTER
    },
    FINANCE_APPROVAL: {
      'step-back': 'ASSIGNEE_STEP_INCLUDED',
      'step-approve': 'ASSIGNEE_STEP_INCLUDED'
    },
    UPLOAD_ARTWORK: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-cancel': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    PO: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    PO_APPROVAL: {
      ENABLED: [SpecificRoles.PPM, 'GROUP_FN_PRODUCEIT_PO_APPROVER_1', 'GROUP_FN_PRODUCEIT_PO_APPROVER_2'],
    },
    ART_REQUEST_APPROVAL: {
      'step-back': 'PRODUCT_OWNER',
      'step-approve': 'PRODUCT_OWNER'
    },
    PRINT: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-close': 'PRINT_PRODUCTION_MANAGER'
    },
    PRODUCTION_MANAGER: 'GROUP_FN_PRODUCEIT_FSR_PRODUCTION_MANAGER'
  },
  BIF_PRODUCTION_REQUEST: {
    REQUEST_DETAILS: {
      'step-delete': REQUEST_DETAILS_REQUESTER,
      'step-save': REQUEST_DETAILS_REQUESTER,
      'step-submit': REQUEST_DETAILS_REQUESTER
    },
    ARTWORK_UPLOAD_AND_COST_QUOTE_CONFIRMATION: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    FINANCE_APPROVAL: {
      'step-back': 'ASSIGNEE_STEP_INCLUDED',
      'step-approve': 'ASSIGNEE_STEP_INCLUDED'
    },
    PO: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    PO_APPROVAL: {
      ENABLED: [SpecificRoles.PPM, 'GROUP_FN_PRODUCEIT_PO_APPROVER_1', 'GROUP_FN_PRODUCEIT_PO_APPROVER_2'],
    },
    PRINTER_PROOF_REQUEST: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    INTERNAL_PRINTER_PROOF_REVIEW: {
      'step-back': REQUEST_DETAILS_REQUESTER,
      'step-approve': REQUEST_DETAILS_REQUESTER
    },
    PRINT: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-close': 'PRINT_PRODUCTION_MANAGER'
    },
    PRODUCTION_MANAGER: 'GROUP_FN_PRODUCEIT_BIF_PRODUCTION_MANAGER'
  },
  PRODUCTION_REQUEST_3RD_PARTY: {
    REQUEST_DETAILS: {
      'step-delete': REQUEST_DETAILS_REQUESTER,
      'step-save': REQUEST_DETAILS_REQUESTER,
      'step-submit': REQUEST_DETAILS_REQUESTER
    },
    REQUEST_REVIEW: {
      'step-back': ['PRINT_PRODUCTION_MANAGER', 'ASSIGNEE_STEP_INCLUDED'],
      'step-submit': ['PRINT_PRODUCTION_MANAGER', 'ASSIGNEE_STEP_INCLUDED']
    },
    FINANCE_APPROVAL: {
      'step-back': 'ASSIGNEE_STEP_INCLUDED',
      'step-approve': 'ASSIGNEE_STEP_INCLUDED'
    },
    UPLOAD_ARTWORK: {
      'step-back': 'ASSIGNEE_STEP_INCLUDED',
      'step-cancel': 'ASSIGNEE_STEP_INCLUDED',
      'step-submit': 'ASSIGNEE_STEP_INCLUDED'
    },
    ART_REQUEST_APPROVAL: {
      'step-back': 'ASSIGNEE_STEP_INCLUDED',
      'step-approve': 'ASSIGNEE_STEP_INCLUDED'
    },
    PO_SOW_TPS: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    COMMITTEE_APPROVAL: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-approve': 'PRINT_PRODUCTION_MANAGER'
    },
    PO_APPROVAL: {
      ENABLED: [SpecificRoles.PPM, 'GROUP_FN_PRODUCEIT_PO_APPROVER_1', 'GROUP_FN_PRODUCEIT_PO_APPROVER_2'],
    },
    CONFIRM_PRINTER: {
      'step-back': 'PRODUCT_OWNER',
      'step-submit': 'PRODUCT_OWNER'
    },
    INTERNAL_EXTERNAL_OPERATIONS: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-save': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    IN_PRODUCTION: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-close': 'PRINT_PRODUCTION_MANAGER'
    },
    PRODUCTION_MANAGER: 'GROUP_FN_PRODUCEIT_3RD_PARTY_CARD_PRODUCTION_MANAGER',
    TRAFFIC_MANAGER: PermissionGroups['3RD_PARTY_PRODUCTION_TRAFFIC_MANAGER']
  },
  IH_PRODUCTION_REQUEST: {
    REQUEST_DETAILS: {
      'step-delete': REQUEST_DETAILS_REQUESTER,
      'step-save': REQUEST_DETAILS_REQUESTER,
      'step-submit': REQUEST_DETAILS_REQUESTER
    },
    ARTWORK_UPLOAD_AND_COST_QUOTE_CONFIRMATION: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-cancel': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    INTERNAL_REQUESTOR_REVIEW: {
      'step-back': REQUEST_DETAILS_REQUESTER,
      'step-approve': REQUEST_DETAILS_REQUESTER
    },
    PO: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    PO_APPROVAL: {
      ENABLED: [SpecificRoles.PPM, 'GROUP_FN_PRODUCEIT_PO_APPROVER_1', 'GROUP_FN_PRODUCEIT_PO_APPROVER_2'],
    },
    IH_QUOTE_PROCESS: {
      'step-back': REQUEST_DETAILS_REQUESTER,
      'step-submit': REQUEST_DETAILS_REQUESTER
    },
    PRINTER_PROOF_REQUEST: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-submit': 'PRINT_PRODUCTION_MANAGER'
    },
    INTERNAL_PRINTER_PROOF_REVIEW: {
      'step-back': REQUEST_DETAILS_REQUESTER,
      'step-approve': REQUEST_DETAILS_REQUESTER
    },
    PRINT: {
      'step-back': 'PRINT_PRODUCTION_MANAGER',
      'step-close': 'PRINT_PRODUCTION_MANAGER'
    },
    PRODUCTION_MANAGER: 'GROUP_FN_PRODUCEIT_IHA_PRODUCTION_MANAGER'
  },
  IMAGE_REQUEST: {
    REQUEST_DETAILS: {
      'step-delete': REQUEST_DETAILS_REQUESTER,
      'step-save': REQUEST_DETAILS_REQUESTER,
      'step-submit': REQUEST_DETAILS_REQUESTER
    },
    TM_REVIEW: {
      'step-back': [ASSIGNED_TM],
      'step-submit': [ASSIGNED_TM],
      'view-designer-name': 'ANY'
    },
    DESIGN_PROCESS: {
      'step-submit': [ASSIGNED_DESIGNER],
      'step-back': [ASSIGNED_DESIGNER],
      'step-save': [ASSIGNED_DESIGNER]
    },
    TM_REVIEW_2: {
      'step-back': [ASSIGNED_TM],
      'step-close': [ASSIGNED_TM],
      'view-designer-name': 'ANY'
    },
    TRAFFIC_MANAGERS: 'GROUP_FN_PRODUCEIT_IMAGE_TRAFFIC_MANAGER',
    TRAFFIC_MANAGER: SpecificRoles.ASSIGNED_TM,
    CAN_ASSIGN_TM: 'ROLE_FN_PRODUCEIT_IMAGE_TM_EDIT',
    TM_AUTO_ASSIGN: 'ROLE_FN_PRODUCEIT_IMAGE_TM_EDIT',
    CAN_ASSIGN_DESIGNER: ['GROUP_FN_PRODUCEIT_DESIGNER', 'GROUP_FN_PRODUCEIT_IMAGE_TRAFFIC_MANAGER'],
    DESIGNER_AUTO_ASSIGN: 'GROUP_FN_PRODUCEIT_DESIGNER'
  },
  REPORTS: {
    PO_REPORT_ROLE: 'ROLE_FN_PRODUCEIT_PO_REPORT', // 'GROUP_FN_PRODUCEIT_POP_PRODUCTION_MANAGER'
    SIGNED_PO_REPORT_ROLE: 'ROLE_FN_PRODUCEIT_PO_REPORT', // 'GROUP_FN_PRODUCEIT_POP_PRODUCTION_MANAGER'
    TRAFFIC_TRACKER_ROLE: 'ROLE_FN_PRODUCEIT_TRAFFIC_TRACKER_REPORT' // 'FN_PRODUCEIT_TRAFFIC_TRACKER_REPORT_USER'
  },
  APP: {
    MIMIC_USER: 'ROLE_FN_PRODUCEIT_MIMIC_USER',
    ADMIN: PermissionGroups.ADMIN,
    SUPER_USER: PermissionGroups.SUPER_USER,
    APPROVER: ['GROUP_FN_PRODUCEIT_PO_APPROVER_1', 'GROUP_FN_PRODUCEIT_PO_APPROVER_2'],
    CREATE_REQUEST: ['ROLE_FN_PRODUCEIT_REQUEST_CREATE']
  },
  PO_APPROVAL: {
    STAGE_ONE_APPROVER: ['GROUP_FN_PRODUCEIT_PO_APPROVER_1'],
    STAGE_TWO_APPROVER: ['GROUP_FN_PRODUCEIT_PO_APPROVER_2']
  },
  ALLOWED_PRINT_FINANCE_PO: [
    'GROUP_FN_PRODUCEIT_FINANCE_APPROVER_REBILL',
    'GROUP_FN_PRODUCEIT_FINANCE_APPROVER_PREPAID',
    'GROUP_FN_PRODUCEIT_FINANCE_APPROVER_INCOMM_PAYS',
    'GROUP_FN_PRODUCEIT_POP_PRODUCTION_FINANCE_APPROVER',
    'GROUP_FN_PRODUCEIT_PO_REPORT_USER',
    'GROUP_FN_PRODUCEIT_PO_APPROVER_1',
    'GROUP_FN_PRODUCEIT_PO_APPROVER_2'
  ],
  SETTINGS: {
    EMAIL: GROUP_FN_PRODUCEIT_3RD_PARTY_CARD_PRODUCTION_MANAGER
  }
};
